// <?xml version="1.0" standalone="no"?>
// <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"
//  "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
import React from 'react';

const MenuuLogoSVG = ({ width, height, fill, style }) => {

    return (
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg" style={style}
            width={width} height={height} viewBox="0 0 5076.000000 1504.000000"
            preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,1504.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
                <path fill={fill} d="M28446 11739 c-136 -32 -264 -151 -320 -299 l-21 -55 -5 -3154 -5
                -3154 -2519 3214 c-1429 1823 -2549 3243 -2588 3281 -77 75 -179 132 -267 148
                -82 15 -278 12 -344 -5 -173 -45 -310 -185 -346 -355 -9 -42 -11 -973 -9
                -3850 l3 -3795 23 -56 c74 -185 238 -299 427 -299 199 0 366 118 439 310 l21
                55 5 3237 5 3238 2568 -3284 c1972 -2522 2586 -3302 2650 -3363 141 -133 260
                -180 437 -170 111 6 182 30 254 84 61 47 110 114 139 190 l22 58 3 3810 c1
                2619 -1 3826 -8 3861 -34 162 -155 296 -311 345 -65 20 -184 24 -253 8z"/>
                <path fill={fill} d="M33405 11729 c-139 -48 -242 -150 -299 -298 l-21 -56 0 -2390 c0
                -2524 -1 -2487 46 -2824 93 -667 322 -1240 680 -1701 146 -188 397 -427 594
                -566 377 -266 817 -445 1325 -538 284 -52 398 -61 795 -61 297 0 399 4 515 18
                509 64 883 173 1268 372 749 387 1271 1068 1512 1970 62 230 107 496 142 825
                15 147 24 4793 9 4873 -33 180 -156 325 -320 377 -120 38 -281 20 -385 -43
                -92 -57 -181 -172 -217 -282 -11 -32 -15 -501 -19 -2485 -7 -2625 -3 -2460
                -55 -2760 -126 -735 -477 -1303 -1015 -1640 -353 -222 -799 -343 -1315 -357
                -698 -19 -1279 154 -1725 514 -111 89 -284 273 -371 393 -259 357 -411 765
                -491 1320 l-22 155 -6 2410 c-4 1959 -8 2417 -19 2450 -37 113 -116 217 -209
                276 -109 69 -276 89 -397 48z"/>
                <path fill={fill} d="M44238 11731 c-152 -49 -271 -178 -313 -338 -13 -50 -15 -352 -15
                -2373 0 -1482 4 -2373 10 -2475 65 -999 383 -1782 955 -2350 493 -489 1133
                -778 1955 -881 172 -21 672 -30 870 -15 527 40 962 153 1375 356 649 320 1119
                830 1414 1531 97 232 174 496 238 819 l28 140 3 2671 2 2671 -41 62 c-78 117
                -208 192 -348 199 -100 6 -176 -9 -253 -50 -109 -58 -186 -146 -232 -266 l-21
                -57 -5 -2430 c-6 -2689 -2 -2496 -71 -2852 -249 -1276 -1145 -1967 -2504
                -1930 -332 9 -564 47 -837 137 -881 290 -1430 1027 -1562 2100 -33 265 -36
                469 -36 2705 0 1474 -4 2255 -11 2284 -35 155 -166 294 -320 342 -79 25 -203
                24 -281 0z"/>
                <path fill={fill} d="M483 11715 c-166 -45 -306 -186 -342 -346 -7 -29 -11 -1315 -11
                -3829 0 -4167 -5 -3841 60 -3955 41 -72 127 -150 207 -188 65 -30 74 -32 188
                -32 115 0 123 1 189 33 39 18 90 49 114 69 53 43 115 136 140 207 16 48 17
                243 22 3168 l5 3117 1320 -1942 c970 -1428 1336 -1959 1381 -2005 179 -180
                447 -185 623 -12 37 36 190 251 441 621 212 311 813 1194 1335 1961 l950 1395
                5 -3126 5 -3126 23 -58 c93 -230 353 -359 581 -288 159 49 287 191 321 355 7
                35 9 1236 8 3846 l-3 3795 -37 78 c-26 53 -56 97 -96 136 -102 103 -207 141
                -387 141 -180 0 -293 -40 -396 -139 -46 -44 -371 -527 -1539 -2286 -815 -1227
                -1487 -2235 -1493 -2241 -9 -9 -373 531 -1497 2224 -1052 1584 -1501 2252
                -1540 2292 -63 63 -149 112 -235 135 -75 19 -270 19 -342 0z"/>
                <path fill={fill} d="M12524 11206 c-74 -27 -105 -49 -168 -115 -87 -94 -128 -226 -108
                -348 32 -190 173 -333 358 -363 80 -13 5228 -13 5308 0 338 55 480 467 245
                715 -60 63 -112 96 -188 119 -50 15 -299 16 -2720 15 l-2666 0 -61 -23z"/>
                <path fill={fill} d="M12532 7891 c-194 -67 -319 -278 -283 -476 35 -186 176 -326 361
                -355 90 -14 5210 -14 5300 0 186 30 329 172 360 361 31 179 -70 368 -239 452
                l-66 32 -2690 2 c-2584 2 -2692 2 -2743 -16z"/>
                <path fill={fill} d="M12597 4660 c-176 -30 -318 -178 -349 -363 -29 -177 72 -367 241
                -450 l66 -32 2700 0 2700 0 58 23 c80 33 178 125 217 206 127 262 -30 569
                -316 616 -72 12 -5247 11 -5317 0z"/>
            </g>
        </svg>
    );
}

export default MenuuLogoSVG;




// WEBPACK FOOTER //
// ./src/images/MenuuLogoSVG.js